function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.809 13.671a4.215 4.215 0 014.21 4.032l.005.183v.843a1.686 1.686 0 01-1.56 1.682l-.126.004H5.536a1.686 1.686 0 01-1.682-1.56l-.004-.126v-.843a4.215 4.215 0 014.032-4.21l.183-.005h6.744zM11.437 3.555a4.215 4.215 0 110 8.43 4.215 4.215 0 010-8.43z",
  fill: "#787B86"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 16.899,
  y: 7.041,
  width: 4.251,
  height: 1.709,
  rx: 0.855,
  fill: "#787B86",
  fillOpacity: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 17.745,
  y: 9.699,
  width: 3.404,
  height: 1.709,
  rx: 0.855,
  fill: "#787B86",
  fillOpacity: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 18.596,
  y: 12.358,
  width: 2.554,
  height: 1.709,
  rx: 0.855,
  fill: "#787B86",
  fillOpacity: 0.5
});

var SvgContacts = function SvgContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgContacts;